import React, { Component } from 'react'
import {connect} from 'react-redux'

import { deleteInstructors } from '../../actions/Instructors'

import Modal from '../Modal'

class DeleteInstructor extends Component {
  deleteInstructors () {
    this.props.deleteInstructors({ id: this.props.instructor.id })
  }
  render () {
    const { ajaxStatus } = this.props.instructors
    const i = this.props.instructor
    return (
      <Modal>
        <h3>Eliminare istruttore</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        {i.name} - {i.email}
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.deleteInstructors()}
            >
              elimna
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { deleteInstructors })(DeleteInstructor)



// WEBPACK FOOTER //
// ./src/components/Instructors/DeleteInstructor.js